import axios from 'axios'
import { store } from '../store/index'

// import router from "../routes/routes"
const BASE_API_URL = process.env.VUE_APP_BACKEND_URL

const ajax = axios.create({
  baseURL: BASE_API_URL
})

ajax.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

ajax.interceptors.response.use(response => {
  // TODO: fix this when api server return the status code enveloped
  // if (response.data.status_code == 401) {
  if (response && response.data && response.data.message) {
    let notification = {
      message: response.data.message,
      status: response.data.statusCode,
      datetime: new Date().toLocaleString()
    }
    store.dispatch('SET_NOTIFICATION', notification)
  }

  if (response.data.status_code && response.data.status_code == 401) {
    localStorage.removeItem('token')
    router.push({ name: 'login' })
  } else {
    return response
  }
})

function doLogin(email, password,geetest_challenge,geetest_validate ,geetest_seccode) {
  return ajax
    .post("/auth/login",
      {
        email,
        password,
        geetest_challenge,
        geetest_validate,
        geetest_seccode
      }
    ).then(response => {
      return response
    })
    .catch(error => {
      console.error(error)
    })
}

function doSubmitContact(email, message,name) {
  return ajax
    .post("/contact_me",
      {
        email,
        message,
        name
      }
    ).then(response => {
      return response
    })
    .catch(error => {
      console.error(error)
    })
}

function doSignUp(email, password, repeatPassword) {
  return ajax
    .post("/users/register",
      {
        email,
        password,
        repeatPassword
      }
    ).then(response => {
      return response
    })
    .catch(error => {
      console.error(error)
    })
}

function getClientSwarmito() {
  return ajax
    .get('/client/Swarmito')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getBrowserName() {
  return ajax
    .get('/browsername')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getPlatforms() {
  return ajax
    .get('/platforms')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getBrowserNameCant() {
  return ajax
    .get('/browsername_cant')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getPlatformsCant() {
  return ajax
    .get('/platforms_cant')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}


function getClientSum() {
  return ajax
    .get('/client_sum')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}
function getTelerium() {
  return ajax
    .get('/telerium_sum')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}
function getPeopleOnlineByClien (){
  return ajax
    .get('/people_by_client_endpoint')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getPeopleOnline () {
  return ajax
    .get('/admin/people')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getCountry() {
  return ajax
    .get('/country')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getCountryCant() {
  return ajax
    .get('/country_cant')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getRealTimeLastHour() {
  return ajax
    .get('/realtime')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getRealTimeLastMinutes() {
  return ajax
    .get('/realtime-last-minutes')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}


function getTrackers() {
  return ajax
    .get('/trackers')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getTrackersCant() {
  return ajax
    .get('/trackers_cant')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}
function getUsers() {
  return ajax
    .get('/users')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getContacts() {
  return ajax
    .get('/contact_me')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getBySwarms() {
  return ajax
    .get('/byswarms')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getSwarmByTrackers(id) {
  return ajax
    .get(`/swarm/${id}/trackers`)
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getSwarmByBrowsername(id) {
  return ajax
    .get(`/swarm/${id}/browsername`)
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getSwarmByCountry(id) {
  return ajax
    .get(`/swarm/${id}/country`)
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getSwarmByPlatform(id) {
  return ajax
    .get(`/swarm/${id}/platform`)
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getSwarmByBrowsernameOnWin32(id) {
  return ajax
    .get(`/swarm/${id}/browser/on/win32`)
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getSwarmByBrowsernameOnWin64(id) {
  return ajax
    .get(`/swarm/${id}/browser/on/win64`)
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getSwarmByBrowsernameOnMacIntel(id) {
  return ajax
    .get(`/swarm/${id}/browser/on/MacIntel`)
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getSwarmByBrowsernameOnLinux(id) {
  return ajax
    .get(`/swarm/${id}/browser/on/Linux`)
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getSources(id) {
  return ajax
    .get('/users/source')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function createSource(source) {
  return ajax
    .post("/users/source",
      {
        source
      }
    ).then(response => {
      return response
    })
    .catch(error => {
      console.error(error)
    })
}

function getLastChunks() {
  return ajax
    .get('/stats/last_chunks')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getMonthlySourceStats() {
  return ajax
    .get('/stats/monthly_source_stats')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getHistoricalSourceStats() {
  return ajax
    .get('/stats/historical_source_stats')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getPeopleAmountPerSource() {
  return ajax
    .get('/stats/people_amount')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function captchaRegister() {
  return ajax
    .get('/capcha/register?t=' + (new Date()).getTime())
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

function getAdminSources () {
  return ajax
    .get('/stats/admin_sources')
    .then(response => response)
    .catch(error => {
      console.error(error)
    })
}

export const API = {
  doLogin,
  doSignUp,
  doSubmitContact,
  getClientSwarmito,
  getBrowserName,
  getBrowserNameCant,
  getPlatforms,
  getPlatformsCant,
  getTelerium,
  getClientSum,
  getPeopleOnline,
  getPeopleOnlineByClien,
  getCountry,
  getRealTimeLastHour,
  getRealTimeLastMinutes,
  getCountryCant,
  getTrackers,
  getTrackersCant,
  getBySwarms,
  getSwarmByTrackers,
  getSwarmByBrowsername,
  getSwarmByCountry,
  getSwarmByPlatform,
  getSwarmByBrowsernameOnWin32,
  getSwarmByBrowsernameOnWin64,
  getSwarmByBrowsernameOnMacIntel,
  getSwarmByBrowsernameOnLinux,
  getUsers,
  getContacts,
  getSources,
  createSource,
  getLastChunks,
  getMonthlySourceStats,
  getHistoricalSourceStats,
  getPeopleAmountPerSource,
  captchaRegister,
  getAdminSources
}
